import { render } from "./DocumentTreeToolbar.vue?vue&type=template&id=55f5256f"
import script from "./DocumentTreeToolbar.vue?vue&type=script&lang=js"
export * from "./DocumentTreeToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__